import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import adminLogin from "../../helpers/adminLogin";
import { isAdminLoggedIn } from "../../helpers/adminAuth";
import { IconLock, IconMail, IconShield } from "./AdminIcons";
import "../../Admin.scss";

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@ultrachallenge.rs");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (isAdminLoggedIn()) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    const result = await adminLogin(email, password);
    setLoading(false);

    if (result.code === 200) {
      navigate("/admin");
      return;
    }

    setError(result.message || "Prijava nije uspela");
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-wrap">
        <div className="admin-login-hero">
          <div className="admin-login-badge">
            <IconShield />
          </div>
          <h1>Admin Panel</h1>
          <p>Ultra NCP kampanja</p>
        </div>

        <form className="admin-login-card" onSubmit={handleSubmit}>
          <h2>Prijavite se</h2>

          <label htmlFor="admin-email">Email adresa</label>
          <div className="admin-input-icon">
            <IconMail />
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </div>

          <label htmlFor="admin-password">Lozinka</label>
          <div className="admin-input-icon">
            <IconLock />
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          {error && <p className="admin-error">{error}</p>}

          <button type="submit" className="admin-btn admin-btn-block" disabled={loading}>
            <IconShield />
            {loading ? "Prijava..." : "Prijavi se"}
          </button>
        </form>

        <p className="admin-login-foot">Restricted Access • Admin Only</p>
      </div>
    </div>
  );
};

export default AdminLogin;
